import AllOrders from '../allOrders/AllOrders';

const MerchantRejectedParcels = () => {
	return <AllOrders admin={false} title='All Rejected Parcels' isRejected />;
};

export default MerchantRejectedParcels;
